<template>
  <div>
  <v-data-table
  :headers="headers"
  :items="accountsProcessed"
  :items-per-page="15"
  :sortDesc = sortDesc
  :sortBy = sortBy
  :search="search"
  :footer-props="{
  'items-per-page-text':'Nombre de lignes par page',
  'items-per-page-all-text':'Toutes'
  }"
  class="elevation-1"
  mobile-breakpoint="0"
  >
    <template v-slot:top>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Rechercher"
          single-line
          hide-details
          class="m-0 p-0 shrink"
        ></v-text-field>
        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              dark
              small
              class="mt-auto ml-auto"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon left>mdi-account-plus</v-icon>
              Ajout utilisateur
            </v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="text-h5">Ajout utilisateur</span>
              <v-spacer></v-spacer>
              <v-btn icon @click="dialog = false" >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <v-card-text class="pb-0">
              <v-form ref="formAddAccount" v-model="isAddUserFormValid">
                <v-container>
                  <v-row justify="center" dense>
                    <v-btn-toggle v-model="bulkMode" mandatory dense color="primary">
                      <v-btn :value="false">
                        <v-icon left>mdi-account</v-icon>Ajout simple
                      </v-btn>
                      <v-btn :value="true">
                        <v-icon left>mdi-account-multiple-plus</v-icon>Ajout multiple
                      </v-btn>
                    </v-btn-toggle>
                  </v-row>

                  <v-row>
                    <v-col v-if="!bulkMode" dense
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        class = "textFieldGrid"
                        name="email"
                        label="Nom d'utilisateur/Email*"
                        id="email"
                        v-model="email"
                        prepend-icon="mdi-account-circle"
                        required
                        :rules="[checkIsRequired(email), checkMinLenght(email,3)]"
                        type="email"
                      ></v-text-field>
                    </v-col>

                    <v-col dense
                      cols="12"
                      md="6"
                    >
                      <v-select
                        class = "textFieldGrid"
                        :items='sectorsSelect'
                        item-text="text"
                        item-value="value"
                        v-model="sector"
                        prepend-icon="mdi-map"
                        label="Secteur"
                        required
                        :rules="[checkIsRequired(sector)]"
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row v-if="!bulkMode" dense>
                    <v-col dense
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        class = "textFieldGrid"
                        name="firstname"
                        label="Prénom*"
                        id="firstname"
                        v-model="firstname"
                        :rules="[checkIsRequired(firstname)]"
                      ></v-text-field>
                    </v-col>
                    <v-col dense
                      cols="12"
                      md="6"
                    >
                      <v-text-field
                        class = "textFieldGrid"
                        name="surname"
                        label="Nom de famille*"
                        id="surname"
                        v-model="surname"
                        :rules="[checkIsRequired(surname)]"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col dense
                      cols="12"
                      md="6"
                    >
                      <v-select
                        class = "textFieldGrid"
                        :items='autorisationSelect'
                        item-text="text"
                        item-value="value"
                        v-model="autorisation"
                        prepend-icon="mdi-account-eye"
                        label="Autorisation"
                        required
                        multiple
                        :rules="[checkIsRequired(autorisation)]"
                      ></v-select>
                    </v-col>
                  </v-row>

                  <v-row v-if="bulkMode" dense>
                    <v-col dense cols="12">
                      <v-file-input
                        class = "textFieldGrid"
                        v-model="csvFile"
                        accept=".csv,text/csv"
                        label="Fichier CSV (nom, prénom, email)"
                        prepend-icon="mdi-file-delimited"
                        show-size
                        :rules="[checkIsRequired(csvFile)]"
                        @change="parseCsv"
                      ></v-file-input>
                    </v-col>
                  </v-row>
                  <v-row v-if="bulkMode" dense>
                    <v-col dense cols="12">
                      <v-btn text small color="primary" @click="downloadCsvTemplate">
                        <v-icon left>mdi-microsoft-excel</v-icon>
                        Télécharger un fichier exemple
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row v-if="bulkMode" dense>
                    <v-col dense cols="12">
                      <v-alert
                        v-if="bulkUsers.length"
                        type="info"
                        dense
                        text
                      >
                        {{ bulkUsers.length }} compte(s) détecté(s) dans le fichier.
                      </v-alert>
                      <v-alert
                        v-for="(parseError, idx) in bulkParseErrors"
                        :key="idx"
                        type="warning"
                        dense
                        text
                      >
                        {{ parseError }}
                      </v-alert>
                    </v-col>
                  </v-row>
                  <v-row dense>
                    <v-col dense cols="12">
                      <v-checkbox
                        v-model="notify"
                        label="Notifier par email"
                        prepend-icon="mdi-email-fast"
                        dense
                        hide-details
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>

            <div v-if="isProcessing" class="text-center">
              <v-progress-circular indeterminate color="primary"></v-progress-circular>
            </div>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="close"
              >
                Annuler
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                :disabled="!isAddUserFormValid || isProcessing || (bulkMode && bulkUsers.length === 0)"
                @click="save"
              >
                Sauvegarder
              </v-btn>
            </v-card-actions>

            <v-card-text v-if="listNotifsAccountsCreated.length != 0">
              <v-alert
                type="success"
                dense
                >
                {{ creationSuccessMessage }}
              </v-alert>


              <v-simple-table dark class="mb-2">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-center">
                        Utilisateur créé
                      </th>
                      <th class="text-center">
                        Mot de passe temporaire
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in listNotifsAccountsCreated"
                      :key="item.username"
                    >
                      <td>{{ item.username }}</td>
                      <td>{{ item.password }}</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-btn small color="primary">
                <v-icon left>mdi-microsoft-excel</v-icon>
                <download-csv
                  class = "btn btn-default"
                  :data   = "listNotifsAccountsCreated"
                  :separator-excel = "true"
                  name = "nouveauxComptesDigiski.csv">
                  Export excel
                </download-csv>
              </v-btn>
            </v-card-text>
          </v-card>
        </v-dialog>
      </v-card-title>
    </template>
    <template v-slot:item.actionsAccount="props">
      <v-btn icon>
        <v-icon
        color="blue"
        large
        @click="modifyAccount(props.item.userId)">
          mdi-account-edit
        </v-icon>
      </v-btn>
      <v-btn v-if="props.item.userId != currentUserId"
      icon>
        <v-icon
        color="red"
        large
        @click="deleteAccount(props.item.userId)">
          mdi-delete-circle
        </v-icon>
      </v-btn>
    </template>

  </v-data-table>
  </div>  
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    name: "TableAccounts",
    data () {
      return {
        SECTORS: this.$store.state.authStore.sectorsDistinct,
        sectorsSelect: this.$store.state.authStore.sectorsFormatted,
        autorisation: [],
        sortBy: "surname",
        sortDesc: false,
        search: '',
        dialog: false,
        email: '',
        firstname: '',
        surname: '',
        sector: '',
        isAddUserFormValid: false,
        bulkMode: false,
        csvFile: null,
        bulkUsers: [],
        bulkParseErrors: [],
        notify: true,
        lastNotify: true,
      }
    },
    computed: {
      ...mapGetters([
        "isProcessing",
        "listNotifsAccountsCreated",
      ]),
      autorisationSelect(){
        return this.$store.getters.assignableRoles
      },
      currentUserId(){
        return this.$store.state.authStore.dataUser['userId']
      },
      creationSuccessMessage(){
        const count = this.listNotifsAccountsCreated.length
        const plural = count > 1 ? 's' : ''
        const base = `${count} compte${plural} créé${plural} avec succès`
        if (this.lastNotify) {
          // Un e-mail d'invitation (lien pour définir son mot de passe) a été envoyé :
          // les mots de passe temporaires ne servent alors que de secours.
          return `${base}. Un e-mail invitant à définir le mot de passe a été envoyé à chaque personne ; les mots de passe temporaires ci-dessous ne servent qu'en secours.`
        }
        return `${base}, pensez à copier les mots de passe temporaires ci-dessous !`
      },
      accountsProcessed(){
        let result = this.$store.state.authStore.listAccounts
        result.forEach((element, indexEl) => {
          let sectors = []
          for(let index = 0; index < this.SECTORS.length; index++) {
            if((parseInt(element['sector'], 10) & (1 << index)) > 0){
              sectors.push(this.SECTORS[this.SECTORS.length - 1 - index])
            }          
          }
          result[indexEl]['sector'] = sectors.join('/')
        })
        return result
      },
      headers (){
        var headers = [
          { text: 'Nom', align: 'start', value: 'surname', sortable: true},
          { text: 'Prénom', value: 'firstname', sortable: true },
          { text: "Nom d'utilisateur", value: 'username', sortable: true },
          { text: 'Avatar', value: 'pathAvatar', sortable: true },
          { text: 'Secteur', value: 'sector', sortable: true },
          { text: 'Autorisation', value: 'autorisationName', sortable: true },
          { text: "Modifier compte", value: 'actionsAccount', align: 'center', sortable: false },
        ];
        return headers;
      },
    },
    watch: {
      dialog (val) {
        val || this.close()
      }
    },
    methods: {
      deleteAccount(accountId){
        this.$store.dispatch("deleteAccount", {"accountId":accountId});
      },
      modifyAccount(accountId){
        this.$router.push('/accountDetails/'+accountId)
      },
      close () {
        this.dialog = false
      },
      async save () {
        // Mémorise le choix de notification utilisé pour cette création : resetForm()
        // remet notify à true, donc on ne peut pas s'y fier pour le message de succès.
        this.lastNotify = this.notify
        if (this.bulkMode) {
          await this.$store.dispatch("registerBulkUsers", {users: this.bulkUsers, sector: this.sector, autorisation: this.autorisation, notify: this.notify})
          this.resetForm()
        } else {
          await this.$store.dispatch("registerNewUser", {email: this.email, firstname: this.firstname, surname: this.surname, sector:this.sector, autorisation: this.autorisation, notify: this.notify}).then(
            this.resetForm()
          )
        }
      },
      parseCsv (file) {
        this.bulkUsers = []
        this.bulkParseErrors = []
        if (!file) {
          return
        }
        const reader = new FileReader()
        reader.onload = (event) => {
          const text = event.target.result
          const lines = text.split(/\r\n|\n|\r/).filter(line => line.trim() !== '')
          lines.forEach((line, index) => {
            const separator = line.indexOf(';') !== -1 ? ';' : ','
            const columns = line.split(separator).map(column => column.trim().replace(/^"|"$/g, ''))
            // Ignore une éventuelle ligne d'en-tête (ne contient pas d'adresse mail)
            if (index === 0 && line.indexOf('@') === -1) {
              return
            }
            if (columns.length < 3) {
              this.bulkParseErrors.push(`Ligne ${index + 1} ignorée (format attendu : nom, prénom, email)`)
              return
            }
            const [surname, firstname, email] = columns
            if (!surname || !firstname || !email) {
              this.bulkParseErrors.push(`Ligne ${index + 1} incomplète`)
              return
            }
            this.bulkUsers.push({surname: surname, firstname: firstname, email: email})
          })
        }
        reader.readAsText(file)
      },
      downloadCsvTemplate(){
        // Modèle au format attendu par parseCsv : nom ; prénom ; email
        // Séparateur ';' + BOM UTF-8 pour une ouverture correcte dans Excel (FR).
        const rows = [
          ['Nom', 'Prénom', 'Email'],
          ['Dupont', 'Jean', 'jean.dupont@exemple.fr'],
          ['Martin', 'Sophie', 'sophie.martin@exemple.fr'],
        ]
        const content = rows.map(row => row.join(';')).join('\r\n')
        const blob = new Blob(['﻿' + content], {type: 'text/csv;charset=utf-8;'})
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'modele_import_comptes.csv')
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      },
      resetForm(){
        this.$refs.formAddAccount.reset()
        this.csvFile = null
        this.bulkUsers = []
        this.bulkParseErrors = []
        this.notify = true
      },
      checkIsRequired: function(value, errorMessage) {
      if (!errorMessage) {
        errorMessage = "Ce champ est nécessaire";
      }
      return !!value || errorMessage;
      },
      checkMinLenght(value, minLength, errorMessage) {
        let valueLength = 0
        if (value !== null) {
          valueLength = value.length
        }
        
        if (!errorMessage) {
          errorMessage = `La longueur minimale est ${minLength}`;
        }
        return (!!valueLength && valueLength >= minLength) || errorMessage;
      },
    },
    mounted() {
      this.$store.dispatch("getRoles")
      this.$store.dispatch("updateListAccounts");
    }
  }


</script>

<style scoped>
.textFieldGrid {
  padding-top: 0px;
}
</style>